import { ModelBase } from './base';
export class Company extends ModelBase{
  name: string;
  phone: string;
  email: string;
  website: string;
  address: string;
  zipcode: string;
  city: string;
  country: string;
  number: number;
  vat_id: number;
  logo_name: string;
  folder_text: string;
}


// WEBPACK FOOTER //
// ./src/models/company.ts